import React from 'react'
import PropTypes from 'prop-types'
import { FeedbackFish } from '@feedback-fish/react'
import { Fab, Action } from 'react-tiny-fab';

import Footer from '@components/Footer'
import { Box } from '@components/Grid'
import GlobalStyles from '@style/GlobalStyles'
import styled, { ThemeProvider, theme } from '@style'
import { withTranslation } from 'react-i18next'
import { Head } from '@wapps/gatsby-plugin-i18next'
import Button from '@components/Button'
import {Help} from '@components/Icon'

const OuterWrapper = styled.div`
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07);
  max-width: 1440px;
  margin: 0 auto;
  overflow-y: hidden;
  background: #fff;
`

const Background = styled.div`
  width: 100%;
  background: hsla(228, 38%, 92%, 1);
`

const Layout = ({ children }) => (
  <ThemeProvider theme={theme}>
    <>
      <Head hreflang />
      <GlobalStyles />
    
      <Background>
        <OuterWrapper>
          <Box m="0 auto">
            {children}
            <Box>
              <Footer />
            </Box>
          </Box>
        </OuterWrapper>

        <FeedbackFish projectId="04af2076323b69">
          <Fab mainButtonStyles={{ backgroundColor: '#63b3ed' }} icon={<Help />}>Send feedback</Fab>
        </FeedbackFish>
      </Background>
    </>
  </ThemeProvider>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

const LayoutWithTranslation = withTranslation()(Layout)

export { LayoutWithTranslation as Layout }
